import axios from 'axios'

const state = {
  pageNr: 1,
  statusUpdates: [],
  organization: null,
  organizationEvents: [],
  organizations: [],
  filteredOrganizations: [],
  page: 1,
  perPage: 10,
  total: 0,
  loaded: false,
  currentFilters: {},
}

const getters = {
  getPageNr(state) {
    return state.pageNr
  },
  getStatusUpdates(state) {
    return state.statusUpdates
  },
  getOrganization(state) {
    return state.organization
  },
  getOrganizations(state) {
    return state.organizations
  },
  getFilteredOrganizations(state) {
    return state.filteredOrganizations
  },
}

const mutations = {
  SET_PAGENR(state, newValue) {
    state.pageNr = newValue
  },
  SET_STATUS_UPDATES(state, newValue) {
    if (state.pageNr === 1) {
      state.statusUpdates = newValue
    } else {
      state.statusUpdates = state.statusUpdates.concat(newValue)
    }
  },
  UPDATE_STATUS_UPDATE(state, newValue) {
    state.statusUpdates.forEach((element, index) => {
      if (element.id === newValue.id) {
        state.statusUpdates[index] = newValue
      }
    })
  },
  SET_ORGANIZATION(state, newValue) {
    state.organization = newValue
  },
  SET_ORGANIZATION_EVENTS(state, newValue) {
    state.organizationEvents = newValue
  },
  SET_ORGANIZATIONS(state, newValue) {
    state.organizations = newValue
  },
  SET_FILTERED_ORGANIZATIONS(state, newValue) {
    state.filteredOrganizations = newValue
  },
  SET_PAGE(state, newValue) {
    state.page = newValue
  },
  SET_TOTAL(state, newValue) {
    state.total = newValue
  },
  SET_LOADED(state, newValue) {
    state.loaded = newValue
  },
  SET_CURRENT_FILTERS(state, newValue) {
    state.currentFilters = newValue
  },
}

const actions = {
  fetchOrganizations({ commit, dispatch, getters }) {
    return axios.get('/api/v1/organizations').then((response) => {
      commit('SET_ORGANIZATIONS', response.data)
      return response.data
    })
  },
  fetchFilteredOrganizations({ commit, state, dispatch }, { filters }) {
    commit('SET_LOADED', false)
    commit('SET_CURRENT_FILTERS', filters)
    const params = new URLSearchParams()

    if (filters.name) {
      params.append('name', filters.name)
    }
    if (filters.location) {
      params.append('location', filters.location)
    }
    if (filters.cause_ids && filters.cause_ids.length > 0) {
      filters.cause_ids.forEach((id) => {
        params.append('cause_ids[]', id)
      })
    }

    // Add pagination params
    params.append('page', state.page)
    params.append('per_page', state.perPage)

    // Fetch causes first, then organizations
    return axios
      .get('/api/v1/causes')
      .then((causesResponse) => {
        const causes = causesResponse.data
        const causesMap = {}
        causes.forEach((cause) => {
          causesMap[cause.id] = cause.name
        })

        return axios
          .get(`/api/v1/organizations/search?${params.toString()}`)
          .then((response) => {
            // Handle paginated response
            const responseData = response.data
            const organizations = responseData.data || []

            // Transform organizations to match the expected structure
            const transformedOrgs = organizations.map((org) => ({
              ...org,
              image_url: org.logo, // Map logo to image_url for consistency
              cause_name: causesMap[org.cause_id] || 'N/A', // Map cause_id to cause name
            }))

            commit('SET_FILTERED_ORGANIZATIONS', transformedOrgs)
            commit('SET_TOTAL', responseData.total || 0)
            commit('SET_LOADED', true)
            return response.data
          })
      })
      .catch((error) => {
        console.error('Error fetching filtered organizations:', error)
        commit('SET_FILTERED_ORGANIZATIONS', [])
        commit('SET_TOTAL', 0)
        commit('SET_LOADED', true)
        return []
      })
  },
  setPage({ commit, dispatch, state }, page) {
    commit('SET_PAGE', page)
    // Re-fetch with current filters and new page
    dispatch('fetchFilteredOrganizations', { filters: state.currentFilters })
  },
  fetchStatusUpdates({ commit, dispatch, getters }, { organizationId }) {
    return axios
      .get(
        `/api/v1/organization/${organizationId}/status_updates/${getters.getPageNr}/type`
      )
      .then((response) => {
        commit('SET_STATUS_UPDATES', response.data)
        commit('SET_PAGENR', getters.getPageNr + 1)
        return response.data
      })
  },
  fetchOrganization({ commit, dispatch, getters }, { organizationId }) {
    return axios
      .get(`/api/v1/organization/${organizationId}`)
      .then((response) => {
        commit('SET_ORGANIZATION', response.data)
        return response.data
      })
  },
  postNewComment(
    { commit, dispatch, getters },
    { content, statusUpdateId, userId }
  ) {
    return axios
      .post(`/api/v1/comment`, {
        content: content,
        status: 'approved',
        status_update_id: statusUpdateId,
        user_id: userId,
      })
      .then((response) => {
        return response.data
      })
  },
  likeComment({ commit, dispatch, getters }, { commentId }) {
    return axios
      .post(`/api/v1/comments/add_like`, {
        commentId: commentId,
      })
      .then((response) => {
        return response.data
      })
  },
  likePost({ commit, dispatch, getters }, { statusUpdateId }) {
    return axios
      .post(`/api/v1/status_updates/add_like`, {
        statusUpdateId: statusUpdateId,
      })
      .then((response) => {
        return response.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
